import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { Props } from "./types";
import styles from "./styles.scss";

function MaterialResourceForm({ formData, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.materialResourceForm}>
      <div className={styles.row}>
        <div className={styles.group}>
          <h3 className={styles.label}>
            {t("materialResourceForm.nameTitle")}
          </h3>
          <TextInput
            className={styles.input}
            placeholder={t("materialResourceForm.namePlaceholder")}
            value={formData.name}
            input={(name) => edit({ ...formData, name })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("materialResourceForm.descriptionTitle")}
        </h3>
        <TextInput
          className={styles.textArea}
          value={formData.description}
          placeholder=""
          input={(description) => edit({ ...formData, description })}
          isMultiline
        />
      </div>
    </div>
  );
}

export { MaterialResourceForm };
